const smallWords = [
  'a',
  'an',
  'and',
  'as',
  'at',
  'but',
  'by',
  'for',
  'from',
  'in',
  'into',
  'nor',
  'of',
  'on',
  'onto',
  'or',
  'per',
  'so',
  'the',
  'to',
  'up',
  'via',
  'with',
];

export const toTitleCase = (input?: string | null) => {
  if (!input) {
    return '';
  }
  const words = input.split(/\s+/);

  const titleCasedWords = words.map((word) => {
    if (word.includes('-')) {
      const hyphenatedParts = word.split('-');
      const capitalizedParts = hyphenatedParts.map((part) => {
        if (!smallWords.includes(part.toLowerCase())) {
          return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
        } else {
          return part.toLowerCase();
        }
      });

      return capitalizedParts.join('-');
    } else if (word.includes('/')) {
      const slashedParts = word.split('/');
      const capitalizedParts = slashedParts.map((part) => {
        return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
      });
      return capitalizedParts.join('/');
    } else {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }
  });
  return titleCasedWords.join(' ');
};

// eslint-disable-next-line no-control-regex
export const stripUnicode = (str: string) => str.replace(/[^\x00-\x7F]/g, '');
